import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-server-error',
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.scss'],
})
export class ServerErrorComponent {}
